module.exports = __webpack_public_path__ + "img/vp-pause.84593c33.svg";